import theme from '../../../theme';
export var getBorderColor = function (states) {
    if (states === 'Validated')
        return theme.primaryColours.mint.darkMint;
    if (states === 'Errored')
        return theme.primaryColours.amber.darkAmber;
    return theme.primaryColours.paleGray.main;
};
export var DropdownWidth;
(function (DropdownWidth) {
    DropdownWidth["Small"] = "160px";
    DropdownWidth["Medium"] = "208px";
    DropdownWidth["Large"] = "389px";
})(DropdownWidth || (DropdownWidth = {}));
